import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idContasPagarRateio: number | null, openState: boolean) => void,
    onActionDelete: (idContasPagarRateio: number | null, openState: boolean) => void,

}

export const GenerateRateioGeralListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {

    return [
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro de Custo",
            flex: 1,
            minWidth: 180,
            maxWidth: 200,
            sortable: false,
        },
        {
            field: "nroNotaFiscal",
            filterable: false,
            headerName: "N° Nota Fiscal",
            flex: 1,
            minWidth: 180,
            maxWidth: 200,
            sortable: false,
        },
        {
            field: "valorRateio",
            filterable: false,
            headerName: "Valor Rateio",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "data",
            filterable: false,
            headerName: "Data",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },

        {
            field: 'idContasPagar',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}